var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _path, _g22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRTruckLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-truck-left",
    x: 0,
    y: 0,
    width: 28,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63,20.5c-0.005,-0.016 -0.008,-0.032 -0.006,-0.045c0.007,-0.009 0.016,-0.016 0.026,-0.022c0.002,-0.001 0.005,-0.003 0.008,-0.004l-0,-0.001l-0,0c-0.013,0.004 -0.024,0.011 -0.032,0.021l-0.002,0.006c-0.009,0.013 -0.015,0.028 -0.015,0.045l0.021,0Zm-0.025,-0c0,-0.02 0.008,-0.038 0.021,-0.051c0.004,-0.014 0.015,-0.023 0.036,-0.024c0.001,-0 0.001,-0 0.002,-0l0.016,-0c-0.001,-0 -0.002,-0 -0.004,-0l0.008,-0c0.864,-0.007 1.633,-0.384 2.162,-0.984c-0,0 0,0 0,0c0.295,-0.331 0.515,-0.73 0.635,-1.171c0.009,-0.032 0.039,-0.055 0.073,-0.055c0.175,0 7.644,-0 7.998,-0c0.034,-0 0.064,0.023 0.073,0.056c0.334,1.248 1.473,2.167 2.825,2.167c1.35,0 2.488,-0.916 2.824,-2.16c0.009,-0.033 0.039,-0.056 0.073,-0.056c0.095,0 0.806,0 0.806,0c0.385,0 0.698,-0.312 0.698,-0.697c-0,-0.385 -0.313,-0.698 -0.698,-0.698l-0.8,0c-0.034,0 -0.064,-0.023 -0.073,-0.056c-0.329,-1.255 -1.472,-2.183 -2.83,-2.183c-1.355,0 -2.496,0.924 -2.828,2.176c-0.008,0.033 -0.038,0.056 -0.072,0.056l-7.987,-0.001c-0.034,-0 -0.064,-0.024 -0.073,-0.057c-0.327,-1.257 -1.472,-2.187 -2.831,-2.187c-1.36,-0 -2.504,0.93 -2.831,2.187c-0.009,0.034 -0.039,0.057 -0.073,0.057l-2.306,-0l-0.003,-0.001c-0.014,-0.002 -0.072,-0.014 -0.072,-0.076l-0,-5.282c-0,-0.042 0.034,-0.075 0.075,-0.075l5.552,-0c0.041,-0 0.075,0.033 0.075,0.075l0,1.132c0,0.178 0.06,0.331 0.176,0.44c0.119,0.111 0.296,0.174 0.523,0.174l17.55,-0c0.385,-0 0.698,-0.313 0.698,-0.698c-0,-0.385 -0.313,-0.697 -0.698,-0.697c0,-0 -0.159,-0 -0.447,-0c-2.591,-0.002 -15.579,-0.007 -16.232,-0.007c-0.053,-0 -0.09,-0.017 -0.117,-0.041c-0.039,-0.035 -0.056,-0.087 -0.056,-0.134c-0,-0.529 0.01,-5.53 -0,-6.657c-0.001,-0.036 -0,-0.077 0.076,-0.076l9.98,-0.001c0.385,-0 0.697,-0.313 0.697,-0.698c0,-0.384 -0.312,-0.697 -0.697,-0.697c-0,0 -10.754,0 -10.754,0c-0.386,0 -0.699,0.313 -0.699,0.698l-0,2.032c-0,0.021 -0.009,0.041 -0.024,0.055c-0.015,0.014 -0.035,0.021 -0.055,0.02c-0,0 -4.354,0 -4.354,0c-0.599,0 -1.112,0.37 -1.328,0.902c-0.012,0.03 -1.289,3.225 -1.29,3.229c-0.036,0.1 -0.047,0.17 -0.047,0.25c-0,0 -0.001,6.094 -0.001,6.094c0.001,0.792 0.643,1.434 1.435,1.435c0,0 2.352,0 2.352,0c0.034,0 0.064,0.023 0.073,0.056c0.338,1.24 1.474,2.154 2.822,2.154c-0.041,-0 -0.075,0.033 -0.075,0.074l0.021,0.001Zm13.845,-4.465c0.816,-0 1.479,0.662 1.479,1.478c-0,0.816 -0.663,1.479 -1.479,1.479c-0.816,-0 -1.478,-0.663 -1.478,-1.479c-0,-0.816 0.662,-1.478 1.478,-1.478Zm-13.791,-0.014c0.816,0 1.478,0.663 1.478,1.479c0,0.816 -0.662,1.478 -1.478,1.478c-0.816,0 -1.478,-0.662 -1.478,-1.478c-0,-0.816 0.662,-1.479 1.478,-1.479Zm0.342,-8.319c0.035,-0 0.075,0.04 0.075,0.076c0,0.368 -0,2.135 -0,2.135c-0,0.042 -0.034,0.075 -0.075,0.075l-5.183,0c-0.025,0 -0.048,-0.012 -0.062,-0.033c-0.014,-0.021 -0.017,-0.047 -0.008,-0.07l0.855,-2.136c0.011,-0.028 0.039,-0.047 0.07,-0.047l4.328,-0Zm7.876,0.649c-0,0.385 0.312,0.698 0.697,0.698c0,-0 7.756,-0 7.756,-0c0.385,-0 0.698,-0.313 0.698,-0.698c-0,-0.385 -0.313,-0.697 -0.698,-0.697l-7.756,-0c-0.385,-0 -0.697,0.312 -0.697,0.697Z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRTruckLeft);
export default __webpack_public_path__ + "static/media/iconR-truck-left.f0b41649e57821ee7999637f90a3f284.svg";
export { ForwardRef as ReactComponent };